import React, { FC } from 'react';
import { Contact } from '../interfaces/Contact';
import Address from './Address';
import { StyledDiv } from './ContactInformation.styles';
import Email from './Email';
import Faxes from './Faxes';
import OpeningHours from './OpeningHours';
import Phones from './Phones';
import ServiceCenter from './ServiceCenter';

export interface ContactInformationProps {
  contact: Contact;
}

const ContactInformation: FC<ContactInformationProps> = ({ contact, ...props }) => (
  <StyledDiv {...props}>
    <ServiceCenter contact={contact} />
    <Address contact={contact} />
    <Phones contact={contact} />
    <OpeningHours contact={contact} />
    <Faxes contact={contact} />
    <Email contact={contact} />
  </StyledDiv>
);

export default ContactInformation;
